<template>
  <v-form @submit.prevent="search"
          autocomplete="off"
          role="search"
          class="search-form flex-grow-1">
    <v-text-field v-model.trim="form.query"
                  placeholder="Search"
                  outlined
                  dense
                  hide-details
                  append-icon="fal fa-search"
                  @click:append="search">
    </v-text-field>
  </v-form>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';

export default {
  data() {
    return {
      form: new Form({
        query: '',
      })
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
  },
  created() {
    if (this.$route.query.query) {
      this.form.query = this.$route.query.query;
      this.search();
    }
  },
  methods: {
    search() {
      const nonce = Date.now();
      this.$router.push({name: 'library.search', query: {offset: 0, query: this.form.query, nonce: nonce, sort: '',}})
        .catch(err => { // MLD-5116
          if (err.name !== 'NavigationDuplicated'
            && err.message.includes('Avoided redundant navigation to current location') === false) {
            throw err;
          }
        });
    }
  }
}
</script>
